<template>
  <div>
    <v-app-bar v-if="session" fixed app elevation="5" min-height='5' color="red">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" dark />
      <template v-if="paymentStatus === 'noCash'">
          <v-spacer></v-spacer>
          <!-- <v-alert
            class="mt-3"
            dense
            prominent
            color="warning"
            icon="mdi-alarm-multiple"
            dark
          >
            <v-row align="center">
              <v-col class="grow">
                โปรดชำระเงิน ภายในวันที่ 7 ของทุกเดือนเพื่อการใช้งานที่ต่อเนื่อง
              </v-col>
              <v-col class="shrink" @click="gotoBilling()">
                <v-btn small>ชำระค่าบริการ</v-btn>
              </v-col>
            </v-row>
          </v-alert> -->
      </template>
      <template v-if="paymentStatus === 'wait'">
        <v-spacer></v-spacer>
        <v-alert
          class="mt-3"
          dense
          prominent
          color="warning"
          icon="mdi-cash-remove"
          dark
        >
          <v-row align="center">
            <v-col class="grow">
              สลิปของท่านไม่ถูกต้อง
            </v-col>
            <v-col class="shrink" @click="gotoBilling()">
              <v-btn small>อัพเดทสลิป</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </template>
      <v-spacer></v-spacer>
      <!-- <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon x-large v-on="on">
            <v-avatar color="brown" size="40">
              <v-img :src="session.data.logo"></v-img>
            </v-avatar>
          </v-btn>
        </template>
          <v-list-item-content class="justify-center" >
            <div>
              <v-container>
                <v-row>
                  <v-col cols="4" style="padding-right:0">
                    <v-avatar color="brown" size="40">
                      <v-img :src="session.data.logo"></v-img>
                    </v-avatar>
                  </v-col>
                  <v-col cols="8">
                    <h3>{{ session.data.name }}</h3>
                    <p style="font-size:10px" class="text-caption mt-1">
                      {{ typeUser }}
                    </p>
                  </v-col>
                </v-row>
              </v-container>

              <v-divider class="my-3"></v-divider>
              <v-btn depressed rounded text @click.prevent="logout()">
                ออกจากระบบ
              </v-btn>
            </div>
          </v-list-item-content>
      </v-menu> -->

      <v-menu bottom min-width="200px" rounded offset-y>
        <template v-slot:activator="{ on }">
          <p v-on="on" style="color: white !important;font-weight: 0 !important" class="mb-0">{{session.data.name}}</p>
          <v-btn icon x-large v-on="on">
            <v-avatar color="brown" size="40">
              <v-img :src="session.data.logo" contain></v-img>
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list-item-content class="justify-center">
            <div>
              <v-container>
                <v-row>
                  <v-col cols="4" style="padding-right:0">
                    <v-avatar color="brown" size="40">
                      <v-img :src="session.data.logo" contain></v-img>
                    </v-avatar>
                  </v-col>
                  <v-col cols="8">
                    <h3>{{ session.data.name }}</h3>
                    <p style="font-size:10px" class="text-caption mt-1">
                      {{ typeUser }}
                    </p>
                  </v-col>
                </v-row>
              </v-container>

              <v-divider class="my-3"></v-divider>
              <!-- <v-switch
                style="padding-left:16px"
                v-model="shopStatus"
                inset
                label="ปิดร้านค้า"
                @change="updateStatusActive"
              ></v-switch>
              <v-divider class="my-3"></v-divider> -->
              <v-btn depressed rounded text @click.prevent="logout()">
                ออกจากระบบ
              </v-btn>
            </div>
          </v-list-item-content>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-if="session"
      v-model="drawer"
      dark
      app
      fixed
      style="height:100%"
      :width="235"
    >
      <v-list rounded dense>
        <v-list-item>
          <v-col>
            <v-img
              :src="require('@/assets/LogoBetask.svg')"
              max-width="70px"
            ></v-img>
          </v-col>
          <v-col>
            <v-img
              class="ml-1 mr-9"
              :src="require('@/assets/GroupBetask.svg')"
              max-width="80px"
            ></v-img>
          </v-col>
        </v-list-item>
      </v-list>
      <v-list rounded dense>
        <!-- <v-list-item to="/Master/AddCoin">
          <v-list-item-icon>
            <v-icon color="white">mdi-monitor-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">DashBoard</v-list-item-title>
        </v-list-item> -->
        <v-list-item :to="session.data.shopId !== 'U4e23f7bf31b362622ff7c5c06dfdf350' ? '/DashBoard':'/Core/dashboard-bvp'" v-if="typeUser != 'partner' & typeUser !== 'cashier'">
          <v-list-item-icon>
            <v-icon color="white">mdi-monitor-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">DashBoard</v-list-item-title>
        </v-list-item>
        <v-list-item to="/Master/AddCoin" v-if="typeUser != 'partner'">
          <v-list-item-icon>
            <v-icon color="white">mdi-cellphone</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">เพิ่มคะแนนด้วยเบอร์โทร</v-list-item-title>
        </v-list-item>
        <v-list-item to="/Master/DataMember" v-if="session.data.shopId === 'U97dd281445cde30a599a5f5515a4e937'">
          <v-list-item-icon>
            <v-icon color="white">mdi-barcode-scan</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">เพิ่มคะแนนด้วยบาร์โค้ด</v-list-item-title>
        </v-list-item>
        <v-list-item to="/Master/trade" v-if="typeUser != 'partner' && session.data.shopId !== 'U4e23f7bf31b362622ff7c5c06dfdf350'">
          <v-list-item-icon>
            <v-icon color="white">mdi-wallet-giftcard</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">แลกของรางวัล</v-list-item-title>
        </v-list-item>
        <v-list-item to="/addcoin/slip" v-if="typeUser === 'Operation'">
          <v-list-item-icon>
            <v-icon color="white">mdi-cash-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">ให้คะแนนจาก slip</v-list-item-title>
        </v-list-item>
        <v-list-item to="/Core/ReportActivity" v-if="typeUser !== 'Operation' & typeUser !== 'partner' & typeUser !== 'cashier'">
          <v-list-item-icon>
            <v-icon color="white">mdi-view-grid</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">รายงานกิจกรรม</v-list-item-title>
        </v-list-item>
        <v-list-item to="/System/link" v-if="typeUser !== 'Operation' & typeUser !== 'partner' & typeUser !== 'cashier' ">
          <v-list-item-icon>
            <v-icon color="white">mdi-link</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">ลิงก์</v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/Core/VGroupShortcuts"
          v-if="
            $session.getAll().data.shopId === 'Uc520945108b983b6e739ed0a8cd8dae4'
          "
        >
          <v-list-item-icon>
            <v-icon color="white">mdi-square-inc-cash</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head"
            >VGroup Shortcut</v-list-item-title
          >
        </v-list-item>
      </v-list>
      <v-list>
        <v-list-group
          dense
          :value="false"
          prepend-icon="mdi-graph-outline"
          color="white"
          no-action
          v-if="marketing.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head"
              >เครื่องมือการตลาด</v-list-item-title
            >
          </template>

          <v-list-item
            v-for="(item, i) in marketing"
            :key="i"
            :to="item.to"
            router
            exact
            dense
          >
            <v-list-item-icon>
              <v-icon dense color="white">{{ item.icon }} </v-icon>
            </v-list-item-icon>
            <v-list-item-title dense color="white">
              {{ item.title }}</v-list-item-title
            >
          </v-list-item>
        </v-list-group>
        <v-list-group
          dense
          :value="false"
          prepend-icon="mdi-qrcode-scan"
          color="white"
          no-action
          v-if="point.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head">จัดการคะแนน</v-list-item-title>
          </template>

          <v-list-item
            v-for="(item, i) in point"
            :key="i"
            :to="item.to"
            router
            exact
            dense
          >
            <v-list-item-icon>
              <v-icon dense color="white">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense color="white">{{
              item.title
            }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          dense
          :value="false"
          prepend-icon="mdi-cash"
          color="white"
          no-action
          v-if="cash.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head">ระบบเติมเงิน</v-list-item-title>
          </template>

          <v-list-item
            v-for="(item, i) in cash"
            :key="i"
            :to="item.to"
            router
            exact
            dense
          >
            <v-list-item-icon>
              <v-icon dense color="white">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense color="white">{{
              item.title
            }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          dense
          :value="false"
          prepend-icon="mdi-toolbox "
          color="white"
          no-action
          v-if="member.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head">ลูกค้า</v-list-item-title>
          </template>

          <v-list-item
            v-for="(item, i) in member"
            :key="i"
            :to="item.to"
            router
            exact
            dense
          >
            <v-list-item-icon>
              <v-icon dense color="white"> {{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          dense
          :value="false"
          prepend-icon="mdi-note-text "
          color="white"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head">รายงาน</v-list-item-title>
          </template>
          <v-list-item
            v-for="(item, i) in reports"
            :key="i"
            :to="item.to"
            router
            exact
            dense
        >
        <v-list-item-icon>
                      <v-icon dense color="white">{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title dense>{{ item.title }}</v-list-item-title>
                  </v-list-item>
        </v-list-group>
        <v-list-group
          dense
          :value="false"
          prepend-icon="mdi-cog-transfer-outline"
          color="white"
          no-action
          v-if="settings.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head"><v-list-item-title class="menu-head" style="color: white !important;">ตั้งค่า</v-list-item-title>
              <div v-if="boolenAlert" style="text-align: center;border: solid #ff9100;border-radius: 20px;color: #ff9100;margin-top: 2px;">
                แจ้งเตือน <v-icon size="17" class="iconify mb-1" color="#ff9100" data-icon="line-md:alert"></v-icon>
              </div>
          </v-list-item-title>
          </template>

          <v-list-item
            v-for="(item, i) in settings"
            :key="i"
            :to="item.to"
            router
            exact
            dense
          >
            <v-list-item-icon>
              <v-icon dense color="white">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <div>
              <v-list-item-title dense>{{ item.title }}</v-list-item-title>
              <v-list-item-title dense v-if="boolenAlert && item.title === 'ของรางวัล'"><p class="mb-0" style="text-align: center;border: solid #ff9100;border-radius: 20px;color: #ff9100;margin-top: 2px;padding-right: 10px;padding-left: 10px;">ของรางวัลหมดอายุ</p></v-list-item-title>
            </div>
          </v-list-item>
        </v-list-group>
      </v-list>
      <v-list-item to="/Tool/ApiReference" v-if="$session.getAll().data.userTypeGroup !== 'Operation' & typeUser !== 'partner' & typeUser !== 'cashier'">
          <v-list-item-icon>
            <v-icon color="white">mdi-connection</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">API reference</v-list-item-title>
      </v-list-item>
      <v-list-item to="/billingPlan" v-if="$session.getAll().data.userTypeGroup !== 'Operation' & typeUser !== 'partner' & typeUser !== 'cashier'">
          <v-list-item-icon>
            <v-icon color="white">mdi-cash</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">ชำระเงินรายเดือน</v-list-item-title>
      </v-list-item>
      <v-list-item @click="checkAndPushToBelinked" v-if="$session.getAll().data.userTypeGroup !== 'Operation' & typeUser !== 'partner' & typeUser !== 'cashier'">
          <v-list-item-icon>
            <v-icon color="white">mdi-clipboard-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">Belinked</v-list-item-title>
      </v-list-item>
      <template v-slot:append>
        <v-divider class="ma-0"></v-divider>
        <div class="pa-2 nav-button"></div>
      </template>

      <!--  -->
      <v-dialog v-model="dialogCash" max-width="50%">
        <v-card>
          <v-card-title class="text-h5">
            Be-Loyalty billing plans
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col col="6">
                <v-container class="test-hover">
                  <v-card>
                    <v-row>
                      <v-col col="12">
                        <v-list two-line style="background-color: #1b437c">
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="white">
                                mdi-projector-screen-outline
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title
                                >ระบบที่สามารถใช้งานได้</v-list-item-title
                              >
                              <v-list-item-subtitle class="feature_detail"
                                >สามารถใช้ได้ทั้งหมด</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="white">
                                mdi-account-group
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title>จำนวนสมาขิก</v-list-item-title>
                              <v-list-item-subtitle class="feature_detail"
                                >จำกัดแค่ 100 คน</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="white">
                                mdi-cash-multiple
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title>ราคา</v-list-item-title>
                              <v-list-item-subtitle class="feature_detail"
                                >ฟรี</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                    <div v-if="!btFree" class="text-center plan_button">
                      <v-btn
                        rounded
                        color="primary"
                        class="ma-1"
                        dark
                        @click="updateFreePlan()"
                      >
                        เปลี่ยนแพลน
                      </v-btn>
                    </div>
                    <div v-if="btFree" class="text-center plan_button">
                      <v-btn
                        rounded
                        outlined
                        style="color:teal !important"
                        class="ma-2"
                      >
                        <p style="margin-bottom: 1px !important; color: teal">
                          แพลนปัจจุบัน
                        </p>
                      </v-btn>
                    </div>
                  </v-card>
                </v-container>
              </v-col>
              <v-col col="6">
                <v-container class="test-hover">
                  <v-card>
                    <v-row>
                      <v-col col="12">
                        <v-list two-line style="background-color: #1b437c">
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="white">
                                mdi-projector-screen-outline
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title
                                >ระบบที่สามารถใช้งานได้</v-list-item-title
                              >
                              <v-list-item-subtitle class="feature_detail"
                                >สามารถใช้ได้ทั้งหมด</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="white">
                                mdi-account-group
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title>จำนวนสมาชิก</v-list-item-title>
                              <v-list-item-subtitle class="feature_detail"
                                >ไม่จำกัดจำนวน</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="white">
                                mdi-cash-multiple
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title>ราคา</v-list-item-title>
                              <v-list-item-subtitle class="feature_detail"
                                >฿ 2,999 ต่อเดือน</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                    <div v-if="!btBilling" class="text-center plan_button">
                      <v-btn
                        rounded
                        color="primary"
                        dark
                        class="ma-2"
                        @click="billingPlan()"
                      >
                        เปลี่ยนแพลน
                      </v-btn>
                    </div>
                    <div v-if="btBilling" class="text-center plan_button">
                      <v-btn rounded outlined color="teal" dark class="ma-2">
                        <p style="margin-bottom: 0px !important; color: teal">
                          แพลนปัจจุบัน
                        </p>
                      </v-btn>
                    </div>
                  </v-card>
                </v-container>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--  -->
    </v-navigation-drawer>

  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment-timezone'

export default {
  // props: {
  //   boolenAlert: {
  //     type: Boolean,
  //     default: () => null
  //   }
  // },
  data () {
    return {
      user: {
        initials: 'JD',
        fullName: 'John Doe',
        email: 'john.doe@doe.com'
      },
      boolenAlert: false,
      shopStatus: '',
      title: 'Loyalty',
      drawer: true,
      mini: false,
      session: this.$session.getAll(),
      system: [],
      master: [],
      tool: [],
      broadCast: [],
      Package: [],
      setting: [],
      ManageUser: [],
      game: [],
      items: [],
      report: [],
      dialogCash: false,
      btFree: false,
      btBilling: false,
      typeUser: '',
      //   new
      marketing: [],
      point: [],
      cash: [],
      member: [],
      reports: [],
      settings: [],
      snackbarSchedule: false,
      paymentStatus: '',
      dateCheckBill: '',
      status_check_loyvers: ''
    }
  },
  watch: {
    token (newData, old) {
      console.log(newData)
      console.log(old)
    }
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  async mounted () {
    this.session = this.$session.getAll()
    this.getData()
    console.log('this.$session.getAll().data.userTypeGroup', this.$session.getAll().data.userTypeGroup === 'partner')
    this.items = []
    if (this.$session.getAll().data.userTypeGroup === 'Admin') {
      this.adminChk()
      this.typeUser = 'Admin'
    }
    if (this.$session.getAll().data.userTypeGroup === 'Shop Admin') {
      this.shopAdminChk()
      this.typeUser = 'Admin'
    }
    if (this.$session.getAll().data.userTypeGroup === 'Operation') {
      this.operationChk()
      this.typeUser = 'Operation'
    }
    if ((this.$session.getAll().data.userTypeGroup === 'partner') === true) {
      console.log('sddaa')
      this.partner()
      this.typeUser = 'partner'
    }
    if ((this.$session.getAll().data.userTypeGroup === 'cashier') === true) {
      console.log('sddaa')
      this.cashier()
      this.typeUser = 'cashier'
    }
    await this.checkLoyverse()
    this.$OmiseCard.configure({
      publicKey: this.$omise_public_key
    })

    this.dateCheckBill = moment().format('YYYY-MM')
    let trialsVersionDate = this.$session.getAll().data.trialsVersionDate || ''
    let billingEndDate = this.$session.getAll().data.billingEndDate || ''
    if (trialsVersionDate === '' || moment().format('YYYY-MM-DD HH:mm') > trialsVersionDate) {
      if (parseInt(moment().format('DD')) <= 7) {
        if (billingEndDate === '') {
          this.chkPlan()
        } else {
          if (moment().format('YYYY-MM-DD') > billingEndDate) {
            this.chkPlan()
          }
        }
      } else {
        if (moment().format('YYYY-MM-DD') > billingEndDate) {
          this.chkPlan()
        }
      }
    }
    this.getShopLoyverse()
  },
  methods: {
    async checkLoyverse () {
      await axios
        .get(this.DNS_IP + '/ConnectService/get?name=loyverse&shopId=' + this.$session.getAll().data.shopId)
        .then(res => {
          if (res.data.status === false) {
            this.marketing = this.marketing.filter(item => item.title !== 'คูปอง / ส่วนลด')
          }
        })
    },
    async checkAndPushToBelinked () {
      try {
        axios
          .get(this.DNS_IPBelink + '/sys_shop/get?shopId=' + this.$session.getAll().data.shopId)
          .then(res => {
            if (Array.isArray(res.data)) {
              this.$swal({
                title: 'ต้องการ ไปยัง belink ใช่หรือไม่?',
                type: 'question',
                showCancelButton: true,
                cancelButtonColor: '#b3b1ab',
                confirmButtonText: 'ใช่',
                cancelButtonText: 'ไม่'
              })
                .then(async result => {
                  window.location.href = `https://betask-linked-admin.web.app/Core/Login`
                })
                .catch(error => {
                  console.log('error function deleteDataGlobal : ', error)
                })
            } else {
              this.$router.push('/Belink')
            }
          })
      } catch (error) {
        console.log('error', error)
      }
    },
    async getData () {
      this.dataReady = true
      try {
        axios
          .get(this.DNS_IP + '/only_shop/get?shopId=' + this.$session.getAll().data.shopId)
          .then(res => {
            if (this.shopStatus === 'active') {
              this.shopStatus = false
            } else {
              this.shopStatus = true
            }
          })
      } catch (error) {
        console.log('error', error)
      }
    },
    logout () {
      localStorage.removeItem('data')
      this.$session.destroy()
      this.$session.clear()
      this.$router.push('/Core/Login')
    },
    async adminChk () {
      this.boolenAlert = false
      axios
        .get(
          this.DNS_IP + '/reward/get?shopId=' + this.session.data.shopId
        )
        .then(async (response) => {
          response.data.map((item) => {
            if (new Date().getTime() > new Date(item.endDate).getTime() && item.expireTypeReward === 'FixDate') {
              this.boolenAlert = true
            }
          })
        })
        .catch((error) => {
          console.log(error)
        })
      this.system = [
        { title: 'บัญชี', icon: 'mdi-account-edit', to: '/System/User' },
        {
          title: 'เพิ่มร้านค้า',
          icon: 'mdi-cash-register',
          to: '/System/Shop'
        },
        {
          title: 'รายชื่อร้านค้า',
          icon: 'mdi-playlist-check',
          to: '/System/ListAllShop'
        },
        {
          title: 'กลุ่มผู้ใช้งาน',
          icon: 'mdi-account-group',
          to: '/System/UserTypeGroup'
        }
      ]
      this.master = [
        { title: 'สาขา', icon: 'mdi-home-floor-b', to: '/Master/Branch' },
        {
          title: 'ปรับสีร้านค้า',
          icon: 'mdi-format-color-fill',
          to: '/Master/Color'
        },
        {
          title: 'ระดับบัตรสมาชิก',
          icon: 'mdi-signal-cellular-3',
          to: '/Master/Level'
        },
        {
          title: 'อัตราแลกเปลี่ยนคะแนน',
          icon: 'mdi-atom-variant',
          to: '/Master/ProductExchangeRate'
        },
        {
          title: 'โปรโมชั่น',
          icon: 'mdi-ticket-percent',
          to: '/Master/Promotion'
        }
      ]
      this.tool = [
        {
          title: 'ให้คะแนนจาก slip',
          icon: 'mdi-coin',
          to: '/Master//addcoin/slip'
        },
        {
          title: 'Qr Code Lot',
          icon: 'mdi-book-plus-multiple',
          to: '/Tool/CollectQRCodeLot'
        }
      ]
      this.broadCast = [
        {
          title: 'บรอดแคสต์',
          icon: 'mdi-account-group',
          to: '/BroadCast/Audience'
        },
        // {
        //   title: 'บรอดแคสต์',
        //   icon: 'mdi-bullhorn',
        //   to: '/BroadCast/BroadCast'
        // },
        { title: 'ของรางวัล', icon: 'mdi-gift-open', to: '/Master/Reward' },
        { title: 'กิจกรรม', icon: 'mdi-account-voice', to: '/Tool/Activity' },
        {
          title: 'ติดตามการจัดส่ง',
          icon: 'mdi-stocking',
          to: '/System/Transport'
        }
      ]
      this.setting = [
        { title: 'สาขา', icon: 'mdi-home-floor-b', to: '/Master/Branch' },
        {
          title: 'ปรับสีร้านค้า',
          icon: 'mdi-format-color-fill',
          to: '/Master/Color'
        },
        {
          title: 'ระดับบัตรสมาชิก',
          icon: 'mdi-signal-cellular-3',
          to: '/Master/Level'
        },
        {
          title: 'อัตราแลกเปลี่ยนคะแนน',
          icon: 'mdi-atom-variant',
          to: '/Master/ProductExchangeRate'
        },
        { title: 'ตั้งค่าการแจ้งเตือน', icon: 'mdi-bell-ring', to: '/Master/NoticeManagement', type: 'settings' }
      ]
      this.subsciption = [
        {
          title: 'Billing Information',
          icon: 'mdi-format-color-fill',
          to: '/Master/Color'
        }
      ]
    },
    async shopAdminChk () {
      this.boolenAlert = false
      axios
        .get(
          this.DNS_IP + '/reward/get?shopId=' + this.session.data.shopId
        )
        .then(async (response) => {
          let a = response.data.find((item) => {
            return new Date().getTime() > new Date(item.endDate).getTime() && item.expireTypeReward === 'FixDate'
          })
          if (a) {
            this.boolenAlert = true
          }
        })
        .catch((error) => {
          console.log(error)
        })
      this.marketing = [{
        title: 'บรอดแคสต์',
        icon: 'mdi-account-group',
        to: '/BroadCast/Audience'
      }]
      this.marketing.push(
        {
          title: 'คูปอง / ส่วนลด',
          icon: 'mdi-ticket-confirmation',
          to: '/Master/Discount'
        },
        { title: 'กิจกรรม', icon: 'mdi-account-voice', to: '/Tool/Activity' },
        {
          title: 'ติดตามการจัดส่ง',
          icon: 'mdi-stocking',
          to: '/System/Transport'
        },
        {
          title: 'โปรโมชั่น',
          icon: 'mdi-ticket-percent',
          to: '/Master/Promotion'
        },
        { title: 'ซื้อแพ็กเกจ', icon: 'mdi-package', to: '/Master/Package' },
        {
          title: 'Friend Get Friend',
          icon: 'mdi-account-multiple-plus',
          to: '/System/friendgetfriend'
        },
        {
          title: 'Special Point',
          icon: 'mdi-hand-pointing-right',
          to: '/System/pointFree'
        },
        {
          title: 'ยืนยันการชำระเงิน',
          icon: 'mdi-cash-usd',
          to: '/System/confirmPayment'
        }
      )
      this.point = [
        {
          title: 'ให้คะแนนจาก slip',
          icon: 'mdi-cash-usd',
          to: '/addcoin/slip'
        },
        {
          title: 'Qr Code Lot',
          icon: 'mdi-book-plus-multiple',
          to: '/Tool/CollectQRCodeLot'
        },
        { title: 'ดึงคะแนนกลับ', icon: 'mdi-cash-refund', to: '/Tool/Refund' }
      ]
      this.cash = [
        {
          title: 'เติม/หัก เงิน',
          icon: 'mdi-cash-usd',
          to: '/Credits/Manage'
        }
      ]
      this.member = [
        {
          title: 'ลูกค้าทั้งหมด',
          icon: 'mdi-account-details',
          to: '/System/ListMember'
        }
      ]
      if (this.$session.getAll().data.shopId === 'Ud24ed731982ccf4a47a3476b3627a5e6') {
        this.reports = [
          { title: 'ของรางวัล', icon: 'mdi-file-excel', to: '/Tool/ReportCode' },
          {
            title: 'แพ็กเกจ',
            icon: 'mdi-file-excel',
            to: '/Reports/reportPackage'
          },
          {
            title: 'การให้คะแนน',
            icon: 'mdi-file-excel',
            to: '/Reports/reportAddPoint'
          },
          {
            title: 'แจ้งเตือนล่วงหน้าวันเกิด',
            icon: 'mdi-file-excel',
            to: '/Reports/NotifyBirthDay'
          },
          {
            title: 'ใบเสร็จ',
            icon: 'mdi-file-excel',
            to: '/Reports/reportReceipt'
          },
          {
            title: 'แจกคะแนนวันเกิด',
            icon: 'mdi-file-excel',
            to: '/Reports/reportBirtdayPoint'
          }
        ]
      } else if (this.session.data.shopId === 'U368b12c1406c22b6d6156d8b096db5ab' || this.session.data.shopId === 'U4e23f7bf31b362622ff7c5c06dfdf350') {
        this.reports = [
          { title: 'ของรางวัล', icon: 'mdi-file-excel', to: '/Tool/ReportCode' },
          {
            title: 'แพ็กเกจ',
            icon: 'mdi-file-excel',
            to: '/Reports/reportPackage'
          },
          {
            title: 'การให้คะแนน',
            icon: 'mdi-file-excel',
            to: '/Reports/reportAddPoint'
          },
          {
            title: 'แจ้งเตือนล่วงหน้าวันเกิด',
            icon: 'mdi-file-excel',
            to: '/Reports/NotifyBirthDay'
          },
          {
            title: 'Broadcast',
            icon: 'mdi-file-excel',
            to: '/Reports/reportBroadcast'
          },
          {
            title: 'แจกคะแนนวันเกิด',
            icon: 'mdi-file-excel',
            to: '/Reports/reportBirtdayPoint'
          },
          {
            title: 'คะแนนเพื่อนชวนเพื่อน',
            icon: 'mdi-file-excel',
            to: '/Reports/reportGetFriend'
          },
          {
            title: 'คะแนนผู้ใช้งานใหม่',
            icon: 'mdi-file-excel',
            to: '/Reports/reportSpecialPoin'
          },
          {
            title: 'แบบสอบถาม',
            icon: 'mdi-file-excel',
            to: '/Reports/reportFeedbackBPV'
          },
          {
            title: 'คิวอาร์โค้ดลอท',
            icon: 'mdi-file-excel',
            to: '/Reports/reportQRCodeLot'
          }

        // {
        //   title: 'ใบเสร็จ',
        //   icon: '',
        //   to: '/Reports/reportReceipt'
        // }
        ]
      } else {
        this.reports = [
          { title: 'ของรางวัล', icon: 'mdi-file-excel', to: '/Tool/ReportCode' },
          {
            title: 'แพ็กเกจ',
            icon: 'mdi-file-excel',
            to: '/Reports/reportPackage'
          },
          {
            title: 'การให้คะแนน',
            icon: 'mdi-file-excel',
            to: '/Reports/reportAddPoint'
          },
          {
            title: 'แจ้งเตือนล่วงหน้าวันเกิด',
            icon: 'mdi-file-excel',
            to: '/Reports/NotifyBirthDay'
          },
          {
            title: 'Broadcast',
            icon: 'mdi-file-excel',
            to: '/Reports/reportBroadcast'
          },
          {
            title: 'แจกคะแนนวันเกิด',
            icon: 'mdi-file-excel',
            to: '/Reports/reportBirtdayPoint'
          },
          {
            title: 'คะแนนชวนผู้ใช้งานใหม่',
            icon: 'mdi-file-excel',
            to: '/Reports/reportGetFriend'
          },
          {
            title: 'คะแนนผู้ใช้งานใหม่',
            icon: 'mdi-file-excel',
            to: '/Reports/reportSpecialPoin'
          }
          // {
          //   title: 'Broadcast',
          //   icon: '',
          //   to: '/Reports/reportBroadcast'
          // }
        // {
        //   title: 'ใบเสร็จ',
        //   icon: '',
        //   to: '/Reports/reportReceipt'
        // }
        ]
      }
      if (this.session.data.shopId === 'U368b12c1406c22b6d6156d8b096db5ab') {

      }
      this.report = [
        { title: '', icon: 'mdi-account-voice', to: '/Tool/ReportCode' }
      ]
      this.settings = [
        { title: 'สาขา', icon: 'mdi-home-floor-b', to: '/Master/Branch' },
        {
          title: 'ปรับสีร้านค้า',
          icon: 'mdi-format-color-fill',
          to: '/Master/Color'
        },
        {
          title: 'ระดับบัตรสมาชิก',
          icon: 'mdi-signal-cellular-3',
          to: '/Master/Level'
        },
        {
          title: 'อัตราแลกเปลี่ยนคะแนน',
          icon: 'mdi-atom-variant',
          to: '/Master/ProductExchangeRate'
        },
        { title: 'บัญชี', icon: 'mdi-account-edit', to: '/System/User' },
        { title: 'ร้านค้า', icon: 'mdi-cash-register', to: '/System/EditShop' },
        { title: 'ของรางวัล', icon: 'mdi-gift-open', to: '/Master/Reward' },
        {
          title: 'ตั้งค่าหน้าสมัครสมาชิก',
          icon: 'mdi-account-cog',
          to: '/System/customField'
        },
        // { title: 'บัญชี', icon: 'mdi-account-edit', to: '/System/User' },
        // { title: 'ร้านค้า', icon: 'mdi-cash-register', to: '/System/EditShop' },
        // { title: 'ของรางวัล', icon: 'mdi-gift-open', to: '/Master/Reward' },
        { title: 'ชำระเงิน', icon: 'mdi-cash-usd', to: '/System/pay' },
        {
          title: 'ตั้งค่าแจ้งเตือน',
          icon: 'mdi-bell-ring',
          to: '/System/NotifySetting'
        },
        { title: 'ตั้งค่าการเชื่อมต่อไลน์', icon: 'mdi-access-point', to: '/System/LINEConfigSendMessage', type: 'settings' }

        // {
        //   title: "ตั้งค่าหน้าสมัครสมาชิก",
        //   icon: "mdi-account-settings-variant",
        //   to: "/System/customField"
        // }
      ]
    },
    operationChk () {
      this.report = [
        { title: 'รายงาน', icon: 'mdi-account-voice', to: '/Tool/ReportCode' }
      ]
      this.reports = [
        { title: 'รายงานของรางวัล', icon: '', to: '/Tool/ReportCode' },
        {
          title: 'รายงานแพ็กเกจ',
          icon: '',
          to: '/Reports/reportPackage'
        },
        {
          title: 'รายงานการให้คะแนน',
          icon: '',
          to: '/Reports/reportAddPoint'
        }
      ]
    },
    partner () {
      this.reports = [
        {
          title: 'รายงานแพ็กเกจ',
          icon: '',
          to: '/Reports/reportPackage'
        }
      ]
    },
    cashier () {
      // eslint-disable-next-line no-unused-expressions
      this.reports = [
        { title: 'รายงานของรางวัล', icon: '', to: '/Tool/ReportCode' },
        {
          title: 'รายงานการให้คะแนน',
          icon: '',
          to: '/Reports/reportAddPoint'

        }
      // eslint-disable-next-line no-sequences
      ],
      this.point = [
        {
          title: 'ให้คะแนนจาก slip',
          icon: 'mdi-cash-usd',
          to: '/addcoin/slip'
        },
        {
          title: 'Qr Code Lot',
          icon: 'mdi-book-plus-multiple',
          to: '/Tool/CollectQRCodeLot'
        },
        { title: 'ดึงคะแนนกลับ', icon: 'mdi-cash-refund', to: '/Tool/Refund' }
      ]
    },
    async chkPlane () {
      await axios
        .get(
          this.DNS_IP +
            '/system_shop/get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then(async response => {
          let rs = response.data[0]
          if (response.data.length > 0) {
            if (rs.billingPlan === 'free') {
              this.btFree = true
              this.btBilling = false
            } else {
              this.btFree = false
              this.btBilling = true
            }
          }
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
      this.dialogCash = true
    },
    billingPlan () {
      this.$swal({
        title: 'ต้องการ อัพเดทสมาชิก ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.$OmiseCard.open({
            frameLabel: 'Be-Loyalty',
            amount: 200000,
            currency: 'THB',
            defaultPaymentMethod: 'credit_card',
            onCreateTokenSuccess: nonce => {
              if (nonce.startsWith('tokn_')) {
                this.omiseToken = nonce
                this.getCustomersOmise(nonce)
              } else {
                this.omiseSource = nonce
              }
            }
          })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
      this.dialogCash = true
    },
    async getCustomersOmise (tokn) {
      var dt = {
        email: this.$session.getAll().data.userEmail,
        description: this.$session.getAll().data.name,
        card: tokn,
        shopId: this.$session.getAll().data.shopId
      }
      await axios
        .post(this.DNS_IP + '/omise/customers', dt)
        .then(async response => {
          if (response.data.status) {
            this.chkPlane()
            this.$swal(
              'เรียบร้อย',
              'คุณได้อัพเดทเป็นสมาชิก Premium แล้ว',
              'success'
            )
            setTimeout(() => {
              this.redirexPage()
            }, 1500)
          } else {
            this.$swal('ผิดพลาด', 'กรุณาตรวจสอบข้อมูลครับ', 'error')
          }
        })
    },
    updateFreePlan () {
      this.$swal({
        title: 'ต้องการ อัพเดทสมาชิก ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          var dt = {
            billingPlan: 'free',
            LAST_USER: this.$session.getAll().data.userName,
            billingCustomerId: '',
            billingCustomerCardId: '',
            billingScheduleId: '',
            billingCustomerData: ''
          }
          axios
            .post(
              this.DNS_IP +
                '/sys_shop/edit-free-billplan/' +
                this.$session.getAll().data.shopId,
              dt
            )
            .then(async response => {
              this.chkPlane()
              this.$swal(
                'เรียบร้อย',
                'คุณได้อัพเดทเป็นสมาชิกสายฟรีแล้ว',
                'success'
              )
              setTimeout(() => {
                this.redirexPage()
              }, 1500)
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    redirexPage () {
      this.$router.go()
    },
    async chkPlan () {
      await axios
        .get(
          this.DNS_IP +
              '/system_shop_Payment/get?shopId=' +
              this.$session.getAll().data.shopId +
              '&paymentDate=' + this.dateCheckBill
        )
        .then(async (response) => {
          let rs = response.data
          if (rs.status === false) {
            this.paymentStatus = 'noCash'
          } else {
            this.paymentStatus = rs[0].paymentStatus
          }
        })
    },
    gotoBilling () {
      this.$router.push('/BillingPlan')
    },
    getShopLoyverse () {
      axios
        .get(
          this.DNS_IP + '/ConnectService/get?shopId=' + this.$session.getAll().data.shopId)
        .then(res => {
          if (res.status === 200) {
            if (Array.isArray(res.data) && res.data[0] && res.data[0].status === 1) {
              this.status_check_loyvers = true
            } else {
              this.status_check_loyvers = false
            }
          }
        })
    }
  }
}
</script>

<style lang="css" scoped>
#img_bt {
  width: 50px;
  height: 50px;
}
.feature_detail {
  color: #ddd !important;
}
.test-hover:hover {
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 0px 8px 28px 11px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0px 8px 28px 11px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 8px 28px 11px rgba(0, 0, 0, 0.2);
}
.v-list-item:hover {
  /* background-color: #607EAA; */
  text-decoration: none;
}
.list:active {
  background-color: #607eaa !important;
}
.v-list--dense .v-list-item .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list-item--dense .v-list-item__title {
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.5rem;
}
.v-navigation-drawer__content {
  height: 100%;
  width: 1px;
  overflow-y: auto;
  overflow-x: hidden;
}
.v-list-item--active {
  background-color: var(--nav-text-active);
}
.v-navigation-drawer__content {
  background-color: var(--nav-bg);
}

.theme--light.v-card {
    border-radius: 0px !important;
    margin-top: 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue